import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-16","key":"svg-0"}],["path",{"d":"M9 3v18","key":"svg-1"}],["path",{"d":"M15 3v18","key":"svg-2"}]]

const IconColumns3 = createReactComponent('outline', 'columns-3', 'Columns3', __iconNode);

export default IconColumns3;